var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;
	var tabClass = '';
	var tabLength = tabs.length;
	if(tabLength == 1){
		tabClass = 'hidden'
	}

__p+='\n<div class="list-content list-content-'+
((__t=(tabObjIndex))==null?'':__t)+
'">\n	<div class="tabs-wrapper '+
((__t=(tabClass))==null?'':__t)+
'">\n		<div class="title tab-title">'+
((__t=(lang.template(tabTitle)))==null?'':__t)+
'</div>\n		<ul class="rank-tabs rank-tabs-'+
((__t=(tabObjIndex))==null?'':__t)+
' ">\n			';

				_.each( tabs ,function(item,index){
			
__p+='\n			<li><div class="tab" node-id="tab" data-tabindex="'+
((__t=(tabObjIndex))==null?'':__t)+
'"><span class="text">'+
((__t=(lang.template(item.name)))==null?'':__t)+
'</span></div></li>\n\n			';

				})
			
__p+='\n		</ul>\n	</div>\n	<div class="data-list-'+
((__t=(tabObjIndex))==null?'':__t)+
'">\n		<div class="list-wrapper">\n			';

				_.each( tabs ,function(item,index){
			
__p+='\n				<div node-id="panel"></div>\n			';

				})
			
__p+='\n		</div>\n	</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/template/tab-content.tmpl
// module id = 29
// module chunks = 0